import * as contentful from "contentful";
export const getEntry = (includes, id) =>
  includes.Entry.find(entry => entry.sys.id === id);

export const getAsset = (includes, id) =>
  includes.Asset.find(entry => entry.sys.id === id);

export const contentFullApi = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: "uhuxxitrg1zr",
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken:
    "a668f1bb4d9f2c93e9f6f4dfa8954ea8a1ae452c1a1cfb354293df81f08895e9"
});
